
define('text!LNRS/Components/Templates/ProductIndexProductNameTemplate.html',[],function () { return '<ul>\r\n\t{{#hits}}\r\n\t\t<li data-facetname="{{name}}" {{#skip}} data-skip="true" {{/skip}} class="product-facet-list-item {{#selected}}selected{{/selected}} {{#disabled}}disabled{{/disabled}}">\r\n\t\t\t<span>{{displayName}}</span>\r\n\t\t</li>\r\n\t{{/hits}}\r\n</ul>';});

